import { Component, inject } from '@angular/core';
import { BaseEditorComponent } from '@schir-int-client/tech';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import {
	VerfahrenFacade,
	VerfahrenReferenz,
	VerfahrenResource,
	VerfahrenService,
} from '@schir-int-client/verfahren-shared';

import { AktenzeichenModule } from '@schir-int-client/aktenzeichen';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-zugeordnete-verfahren-dialog',
	imports: [
		MatInputModule,
		ReactiveFormsModule,
		MatIconModule,
		MatButtonModule,
		MatDialogModule,
		AktenzeichenModule,
		FormsModule,
		MatTooltipModule,
	],
	templateUrl: 'zugeordnete-verfahren-dialog.component.html',
	styleUrl: 'zugeordnete-verfahren-dialog.component.scss',
})
export class ZugeordneteVerfahrenDialogComponent extends BaseEditorComponent {
	protected readonly verfahren = <VerfahrenResource>inject(MAT_DIALOG_DATA).verfahren;
	private readonly verfahrenService = inject(VerfahrenService);
	private readonly facade = inject(VerfahrenFacade);

	protected searchAktenzeichen: string = '';
	protected searchedVerfahren: VerfahrenReferenz[] = [];
	protected filteredVerfahren: VerfahrenReferenz[] = [];
	private limited = true;
	protected hasMore = false;
	protected readonly verfahrenControl = new FormControl<VerfahrenReferenz[]>(
		this.verfahren.zuordnungen?.untergeordneteVerfahren ?? [],
		{ nonNullable: true }
	);
	readonly form = new FormGroup({ verfahren: this.verfahrenControl });

	submit(): Promise<boolean> {
		this.facade.setZugeordneteVerfahren(
			this.verfahren,
			this.verfahrenControl.value.map(v => v.verfahrenId)
		);
		return Promise.resolve(true);
	}

	protected closeDialog(): void {
		window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
	}

	protected assignItem(index: number) {
		this.setVerfahrenAndMarkDirty([...this.verfahrenControl.value, this.filteredVerfahren[index]]);
	}

	protected deleteItem(index: number): void {
		this.setVerfahrenAndMarkDirty(this.verfahrenControl.value.filter((_, i) => i !== index));
	}

	protected search(limited: boolean = true): void {
		this.limited = limited;
		this.verfahrenService
			.verfahrenszuordnungSearch(this.verfahren, this.searchAktenzeichen, limited ? 30 : 9999)
			.subscribe(result => {
				this.searchedVerfahren = result._embedded.aktenzeichenAndIdList;
				this.filterVerfahren();
			});
	}

	private setVerfahrenAndMarkDirty(verfahren: { aktenzeichen: string; verfahrenId: number }[]): void {
		this.verfahrenControl.setValue(verfahren);
		this.verfahrenControl.markAsDirty();
		this.filterVerfahren();
	}

	private filterVerfahren() {
		const filtered = this.searchedVerfahren.filter(verfahren => {
			return (
				verfahren.aktenzeichen !== this.verfahren.stammdaten.aktenzeichen &&
				!this.verfahrenControl.value.some(v => verfahren.aktenzeichen === v.aktenzeichen)
			);
		});
		this.hasMore = this.limited && filtered.length > 7;
		this.filteredVerfahren = this.limited ? filtered.slice(0, 7) : filtered;
	}
}
